import { Skeleton } from '@mui/material';

import useStyles from './styles';

const CardResultSkeleton = () => {
  const animation = 'wave';
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Skeleton
        animation={animation}
        variant="rectangular"
        className={classes.picture}
      />
      <div className={classes.cardBody}>
        <div className={classes.nameCtn}>
          <div>
            <Skeleton animation={animation} width={100} />
            <Skeleton animation={animation} width={60} />
          </div>
          <div className={classes.ratingCtn}>
            <Skeleton animation={animation} width={50} />
            <Skeleton animation={animation} width={70} />
          </div>
        </div>
        <div>
          <Skeleton animation={animation} />
          <Skeleton animation={animation} />
        </div>
        <Skeleton animation={animation} />
        <div className={classes.priceBtnCtn}>
          <Skeleton animation={animation} width={100} />
          <Skeleton
            animation={animation}
            variant="rectangular"
            width={110}
            height={44}
          />
        </div>
      </div>
    </div>
  );
};

export default CardResultSkeleton;
